import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: 'What types of products do you source?',
  answer: 'We source across Food & Beverages, FMCG, Household Products, Personal Care & Cosmetics, Consumer Electronics, Textiles, Agricultural Products, and Private Label goods. If you have a specific product category, contact us to discuss.'
}, {
  question: 'Which retail chains do you work with?',
  answer: 'We work with major hypermarkets and supermarket chains including Tesco, Sainsbury’s, Carrefour, Aldi, Lidl, E.Leclerc, Lulu Hypermarket, and many more across the UK, Europe, and Asia.'
}, {
  question: 'Can you represent our products to retail buyers?',
  answer: 'Yes, we act as manufacturers’ representatives. We present your product portfolio to retail procurement teams, negotiate listing agreements, and manage the entire approval process on your behalf.'
}, {
  question: 'How do you ensure product quality and compliance?',
  answer: 'We conduct thorough supplier verification, factory audits, and quality inspections. We also ensure all products meet the regulatory, labeling, and packaging requirements of the target market.'
}, {
  question: 'What regions do you operate in?',
  answer: 'We operate across three key regions: the United Kingdom, Europe (including France, Germany, Spain, and more), and Asia (including the Middle East, India, and Southeast Asia).'
}, {
  question: 'What is your pricing structure?',
  answer: 'Our pricing depends on the scope of services required. We offer project-based fees for specific sourcing or market entry initiatives, and retainer models for ongoing representation and procurement management. Contact us for a tailored quote.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#1a2d4a] relative" data-id="element-273">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-274">
        <div className="text-center mb-16" data-id="element-275">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-276">
            <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-277">
              Common Questions
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-278">
              Frequently Asked Questions
            </h2>
          </motion.div>
        </div>

        <div className="space-y-4" data-id="element-279">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className={`border ${openIndex === index ? 'border-[#d4a853] bg-[#0a1628]' : 'border-white/10 bg-[#0a1628]/50'} transition-colors duration-300`} data-id="element-280">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-281">
                <span className={`font-bold text-lg ${openIndex === index ? 'text-[#d4a853]' : 'text-white'}`} data-id="element-282">
                  {faq.question}
                </span>
                <span className={openIndex === index ? 'text-[#d4a853]' : 'text-gray-400'} data-id="element-283">
                  {openIndex === index ? <Minus size={20} data-id="element-284" /> : <Plus size={20} data-id="element-285" />}
                </span>
              </button>

              <AnimatePresence data-id="element-286">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-287">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-288">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}